module.exports = __webpack_public_path__ + "img/wechat_on.9f32c5b0.png";